module.exports = __webpack_public_path__ + "img/index_part8img.8487edd7.jpg";